import { Box, Typography } from "@mui/material";
import React from "react";
import "./PublicPages.css";

const PrivacyPolicyPublic = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f5f5f5",
        padding: { xs: "20px", sm: "40px", md: "60px" },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          margin: "0 auto",
          bgcolor: "#fff",
          padding: { xs: "20px", sm: "40px" },
          borderRadius: "8px",
          boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontSize: { xs: "24px", sm: "32px" },
            fontWeight: "600",
            marginBottom: "30px",
            color: "#0C2C50",
          }}
        >
          Privacy Policy
        </Typography>

        <Box
          className="public-page-content"
          sx={{
            "& p": {
              marginBottom: "16px",
              lineHeight: "1.6",
              color: "#333",
            },
            "& h1, & h2, & h3, & h4, & h5, & h6": {
              marginTop: "24px",
              marginBottom: "16px",
              color: "#0C2C50",
            },
            "& ul, & ol": {
              marginBottom: "16px",
              paddingLeft: "24px",
            },
            "& li": {
              marginBottom: "8px",
            },
          }}
        >
          <p>
            <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
          </p>
          
          <h2>1. Introduction</h2>
          <p>
            FIDDUX ("we," "our," or "us") is committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard 
            your information when you use our mobile application and services.
          </p>

          <h2>2. Information We Collect</h2>
          <p>We may collect information that you provide directly to us, including:</p>
          <ul>
            <li>Personal identification information (name, email address, phone number)</li>
            <li>Financial information necessary for account management</li>
            <li>Identity verification documents (as required by regulations)</li>
            <li>Transaction history and account activity</li>
          </ul>

          <h2>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and manage your account</li>
            <li>Comply with legal and regulatory requirements</li>
            <li>Send you important updates and notifications</li>
            <li>Protect against fraud and unauthorized access</li>
          </ul>

          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect 
            your personal information against unauthorized access, alteration, disclosure, 
            or destruction. However, no method of transmission over the Internet or 
            electronic storage is 100% secure.
          </p>

          <h2>5. Data Sharing and Disclosure</h2>
          <p>We do not sell, trade, or rent your personal information to third parties. 
          We may share your information only:</p>
          <ul>
            <li>With your explicit consent</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and prevent fraud</li>
            <li>With service providers who assist in our operations (under strict confidentiality agreements)</li>
          </ul>

          <h2>6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your data (subject to legal requirements)</li>
            <li>Object to processing of your data</li>
            <li>Data portability</li>
          </ul>

          <h2>7. GDPR Compliance</h2>
          <p>
            We are committed to compliance with the General Data Protection Regulation (GDPR). 
            If you are located in the European Economic Area (EEA), you have additional rights 
            under GDPR regarding your personal data.
          </p>

          <h2>8. Data Retention</h2>
          <p>
            We retain your personal information for as long as necessary to fulfill the 
            purposes outlined in this Privacy Policy, unless a longer retention period 
            is required or permitted by law.
          </p>

          <h2>9. Changes to This Privacy Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of 
            any changes by posting the new Privacy Policy on this page and updating the 
            "Last Updated" date.
          </p>

          <h2>10. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:order@fiddux.com" style={{ color: "#0C2C50" }}>order@fiddux.com</a><br />
            <strong>Address:</strong> Joe 2, Harjumaa, 10151, Tallinn, Estonia
          </p>
        </Box>

        <Box
          sx={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #e0e0e0",
            textAlign: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "#666" }}>
            Last updated: {new Date().toLocaleDateString()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", marginTop: "8px" }}>
            For questions, contact:{" "}
            <a
              href="mailto:order@fiddux.com"
              style={{ color: "#0C2C50", textDecoration: "none" }}
            >
              order@fiddux.com
            </a>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PrivacyPolicyPublic;
